module.exports = __webpack_public_path__ + "img/main_9.8ec74c2b.jpg";